import { reduxForm } from 'redux-form';
import Component from './PermissionForm';
import { validate } from './validate';

const initialValues = {
  permission: '',
  path: '',
};

const FormPermission = reduxForm({
  form: 'form-permission-user',
  initialValues,
  enableReinitialize: true,
  validate,
})(Component);

export default FormPermission;
